import React, { useEffect, useState } from 'react';
import "./CandidateProject.css"
import TableHeader from '../../Common/TableHeader';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css'
import { useDispatch, useSelector } from 'react-redux';
import { CandidateAddProjectAction } from '../../../Redux/action/CandidateAddProjectAction';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CandidateUpdateProjectAction } from '../../../Redux/action/UpdateProjectAction';
import { CandidateProfile } from '../../../Redux/action/CandidateProfileAction';
import { MdDeleteOutline } from 'react-icons/md';
import { SpinLoader } from "../../Vendor/ImportCandidates";
import { fetchDesignationDetails, fetchSkillDetails } from '../../../Redux/action/MasterSkillAction';

const UpdateProjectForm = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const AllSkillList = useSelector((state) => state?.MasterTableDetails?.skill?.content)
    const AllDesignationList = useSelector((state) => state?.MasterTableDetails?.designation?.content);


    const [project, setProject] = useState({
        projectName: '',
        client: '',
        clientLocation: '',
        startDate: '',
        endDate: '',
        role: '',
        description: '',
        durationValue: '', // Numeric value
        durationUnit: 'Months', // Default unit
        projectIndustry: '',
        newImages: [],
        images: [], // For multiple images
        teamSize: '',
        projectUrl: ''
    });

    // const [newImages, setNewImages] = useState('')

    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { id } = useParams()

    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [selectedSkills, setSelectedSkills] = useState([])
    const [isLoading, setIsloading] = useState(false)

    const candidateId = userResult?.userid;;

    const handleTagsChange = (tags) => {
        setTags(tags);
    };

    useEffect(() => {
        dispatch(fetchSkillDetails())
        dispatch(fetchDesignationDetails())
    }, [])

    const allowedPattern = /^[a-zA-Z0-9 _-]*$/;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "projectName" && !allowedPattern.test(value)) {
            return; // ignore disallowed input
        }
        setProject(prevProject => ({
            ...prevProject,
            [name]: value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const files = Array.from(e.target.files);
        const size = file.size / (1024 * 1024)
        if (size > 1) {
            return toast.error("Please Upload image having size less than 1 MB")
        }
        setProject(prevProject => ({
            ...prevProject,
            images: prevProject.images.concat(files)
        }));

    };

    const location = useLocation();

    useEffect(() => {
        if (location.state === null) {
            dispatch(CandidateProfile(candidateId));
        } else {
            dispatch(CandidateProfile(location.state.id));
        }
    }, []);

    const projectInfo = useSelector((state) => state?.Profile?.result?.candidateProjects?.filter((item) => item.projectId == id)[0]);
    const loading = useSelector((state) => state?.UpdateProject?.loading)

    useEffect(() => {
        if (projectInfo) {
            setProject({
                projectName: projectInfo.projectName || '',
                client: projectInfo.client || '',
                clientLocation: projectInfo.clientLocation || '',
                role: projectInfo.role || '',
                description: projectInfo.description || '',
                durationValue: projectInfo.duration.split(' ')[0] || '',
                durationUnit: projectInfo.duration.split(' ')[1] || 'Months',
                projectIndustry: projectInfo.projectIndustry || '',
                images: projectInfo.projectImages || [],
                teamSize: projectInfo.teamSize || '',
                projectUrl: projectInfo.projectUrl || ''
            });

            // Set tags and selectedSkills if available in projectInfo
            setTags(projectInfo.technologies || []);
            setSelectedSkills(projectInfo.technologies.map(tech => ({ value: tech, label: tech })) || []);
        }
    }, [projectInfo]);

    useEffect(() => {
        dispatch(fetchSkillDetails())
        dispatch(fetchDesignationDetails())
    }, [])


    // console.log('CUR PRO--', selectedSkills)

    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsloading(true)
        const fileSizeLimit = 2 * 1024 * 1024; // 1MB in bytes
        const totalSize = project.images.reduce((acc, image) => acc + image.size, 0);

        if (totalSize >= fileSizeLimit) {
            toast.error("The combined size of all images exceeds the size limit of 2MB.");
            setIsloading(false)
            return;
        }

        // Create a new FormData object
        const formData = new FormData();

        const filteredImages = project.images.filter(image => typeof image === 'string' && image.startsWith('https'));
        const newImages = project.images.filter(image => typeof image !== 'string');
        // Append candidateProjectRequest as a JSON string
        formData.append(
            'candidateProjectRequest',
            JSON.stringify({
                projectName: project.projectName,
                client: project.client,
                clientLocation: project.clientLocation,
                role: project.role,
                technologies: selectedSkills.map(skill => skill.value),
                description: project.description,
                projectId: id,  // Replace with the actual candidate ID
                projectIndustry: project?.projectIndustry,
                projectUrl: project?.projectUrl,
                teamSize: project.teamSize,
                // duration: project.duration,
                projectImages: filteredImages,
                duration: `${project.durationValue} ${project.durationUnit}`,
                candidateId
            })
        );

        // Append each image separately with the key 'projectImages'
        // project.images.forEach((image, index) => {
        //     formData.append('images', image);
        // });

        newImages.forEach((image, index) => {
            formData.append('images', image);
        });

        await dispatch(CandidateUpdateProjectAction(formData, navigate)).then((res) => {
            if (res?.data) {
                setTimeout(() => {
                    setIsloading(false)
                }, 1000);
            }
        }).catch((err) => {
            setTimeout(() => {
                setIsloading(false)
            }, 1000);
        })
        // console.log("Loa -- 2", loading)

    };

    console.log('PROJ IMG--> ', project?.images)


    const handleImageRemove = (index) => {
        const updatedImages = [...project.images];
        updatedImages.splice(index, 1);
        setProject(prevProject => ({
            ...prevProject,
            images: updatedImages
        }));
    };


    // console.log('TAG--', project)

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (inputValue.trim() !== '') {
                setTags([...tags, inputValue.trim()]);
                // e.target.value = '';
                setInputValue('');
            }
        }
    };

    const handleChange = (value) => {
        setInputValue(value);
    };

    // console.log('skills---> ', selectedSkills.map(skill => skill.value))


    const options = AllSkillList?.map((item) => (
        {
            'value': item?.skillName,
            'label': item?.skillName
        }
    ))

    // const options = [
    //     { value: 'HTML', label: 'HTML' },
    //     { value: 'Javascript', label: 'Javascript' },
    //     { value: 'React Js', label: 'React Js' },
    //     { value: 'Css', label: 'Css' },
    //     { value: 'Bootstrap', label: 'Bootstrap' },
    //     { value: 'Java', label: 'Java' },
    //     { value: 'MySql', label: 'MySql' },
    //     { value: 'Spring Boot', label: 'Spring Boot' },
    //     { value: 'Microservices', label: 'Microservices' },
    //     { value: 'Node', label: 'Node' },
    //     { value: 'Express', label: 'Express' },
    //     { value: 'Mongo Db', label: 'Mongo Db' },
    //     { value: 'Automation', label: 'Automation' },
    //     { value: 'Test Case Design', label: 'Test Case Design' },
    //     { value: 'Defect Tracking', label: 'Defect Tracking' },
    //     { value: 'Python', label: 'Python' },
    //     { value: 'Power Bi', label: 'Power Bi' },
    //     { value: 'Data Analyst', label: 'Data Analyst' },
    //     { value: 'Data Science', label: 'Data Science' },
    //     { value: 'MS Word', label: 'MS Word' },
    //     { value: 'MS Excel', label: 'MS Excel' },
    //     { value: 'Go Language', label: 'Go Language' },
    //     { value: 'MS Office', label: 'MS Office' },
    //     { value: 'Ruby on Rails', label: 'Ruby on Rails' },
    //     { value: 'BlockChain', label: 'BlockChain' },
    //     { value: 'Flutter', label: 'Flutter' },
    //     { value: 'React Native', label: 'React Native' },
    //     { value: 'Search Engine Optimization (SEO)', label: 'Search Engine Optimization (SEO)' },
    //     { value: 'Social Media Marketing', label: 'Social Media Marketing' },
    //     { value: 'Email Marketing', label: 'Email Marketing' },
    //     { value: 'Risk Management', label: 'Risk Management' },
    //     { value: 'Ratio Analysis', label: 'Ratio Analysis' },
    //     { value: 'Trend Analysis', label: 'Trend Analysis' },
    //     { value: 'Manual Testing', label: 'Manual Testing' },
    //     { value: 'Automated Testing', label: 'Automated Testing' },
    //     { value: 'Bug Tracking and Test Management Tools', label: 'Bug Tracking and Test Management Tools' },
    //     { value: "Figma", label: "Figma" },
    //     { value: "Adobe XD", label: "Adobe XD" },
    //     { value: "Sketch", label: "Sketch" },
    //     { value: "Balsamiq", label: "Balsamiq" },

    // ]

    const handleSkillsChange = (selectedOptions) => {
        // Update the selected cities in the state
        setSelectedSkills(selectedOptions)
        const selectedValues = selectedOptions.map(option => option.value);
        // setProfileInfo({ ...profileInfo, skillList: selectedValues });
    };


    // console.log("SELECTED SKILL---", selectedSkills)

    return (

        <>
            <ToastContainer />
            <div className='container mt-4'>
                {/* <TableHeader isSearch={false} isFilter={false} heading={'Add Your Projects'} /> */}
                <div className='can_prof_container'>
                    <div className="">
                        {/* Account page navigation*/}
                        {/* <hr className="mt-0 mb-4" /> */}
                        <div className="row d-flex justify-content-center align-items-center">

                            <div className="">
                                {/* Account details card*/}
                                <div className="card can_prof_main">
                                    <div className="card-header prof_header">Update Project</div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="row gx-3 mb-3">
                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputFirstName">
                                                        Project Name
                                                        <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputFirstName"
                                                        type="text"
                                                        name="projectName"
                                                        placeholder="Enter Project Name"
                                                        value={project.projectName}
                                                        onChange={handleInputChange}
                                                        required
                                                        minLength={3}
                                                        maxLength={100}
                                                    />
                                                </div>
                                                {/* Form Group (last name)*/}
                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputLastName">
                                                        Client
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputLastName"
                                                        type="text"
                                                        name='client'
                                                        placeholder="Enter client"
                                                        value={project?.client}
                                                        onChange={handleInputChange}
                                                        minLength={3}
                                                        maxLength={100}
                                                        pattern="^[A-Za-z ]+$"
                                                        title="Only alphabetic characters are allowed"
                                                    />
                                                </div>
                                            </div>
                                            {/* Form Row        */}
                                            <div className="row gx-3 mb-3">
                                                {/* Form Group (organization name)*/}
                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputOrgName">
                                                        Client Location
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputOrgName"
                                                        type="text"
                                                        name='clientLocation'
                                                        placeholder="Enter client location"
                                                        value={project.clientLocation}
                                                        onChange={handleInputChange}
                                                        minLength={3}
                                                        maxLength={100}
                                                    />
                                                </div>

                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputOrgName">
                                                        Project Industry
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputOrgName"
                                                        type="text"
                                                        name='projectIndustry'
                                                        placeholder="Enter project industry"
                                                        value={project.projectIndustry}
                                                        onChange={handleInputChange}
                                                        minLength={3}
                                                        maxLength={100}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row gx-3 mb-3">
                                                {/* Form Group (organization name)*/}
                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputOrgName">
                                                        Role
                                                    </label>
                                                    {/* <input
                                                        className="form-control"
                                                        id="inputOrgName"
                                                        type="text"
                                                        name="role"
                                                        value={project.role}
                                                        placeholder="Enter your role"
                                                        onChange={handleInputChange}
                                                    /> */}

                                                    <select id="inputOrgName" value={project.role} name="role" onChange={handleInputChange} className='form-select'>
                                                        <option value="" disabled hidden>
                                                            Select any role
                                                        </option>
                                                        {AllDesignationList?.map((option) => (
                                                            <option key={option?.designationId} value={option?.designation}>
                                                                {option.designation}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </div>

                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputOrgName">
                                                        Project URL
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputOrgName"
                                                        type="url"
                                                        placeholder="Enter project Url"
                                                        name="projectUrl"
                                                        value={project.projectUrl}
                                                        pattern="https:\/\/.*"  // HTML5 pattern check
                                                        title="url should be start with https://"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Regex to detect emoji characters
                                                            const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

                                                            if (!emojiRegex.test(value)) {
                                                                handleInputChange(e); // Only update state if no emoji
                                                            }
                                                        }}
                                                        maxLength={250}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row gx-3 mb-3">
                                                {/* Form Group (organization name)*/}
                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputOrgName">
                                                        Team Size
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        id="inputOrgName"
                                                        type="number"
                                                        min={0}
                                                        max={500}
                                                        name="teamSize"
                                                        value={project.teamSize}
                                                        placeholder="Enter team size"
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="col-sm-6">
                                                    <div className="input-row gap-0">

                                                        <label className="small mb-1" htmlFor="inputOrgName">
                                                            Duration
                                                            <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                        </label>

                                                        <div className="duration-fields d-flex">
                                                            <select
                                                                className="form-control"
                                                                name="durationValue"
                                                                value={project.durationValue}
                                                                onChange={handleInputChange}
                                                                style={{ width: "78%" }}
                                                                required
                                                            >
                                                                <option value="">Select Duration</option>
                                                                {Array.from(
                                                                    { length: project.durationUnit === "Months" ? 12 : 100 },
                                                                    (_, index) => (
                                                                        <option key={index} value={index}>
                                                                            {index}
                                                                        </option>
                                                                    )
                                                                )}
                                                            </select>

                                                            <select
                                                                name="durationUnit"
                                                                value={project.durationUnit}
                                                                style={{
                                                                    borderRadius: "4px",
                                                                    border: "1px solid lightgray",
                                                                    width: "23%",
                                                                    marginLeft: "5px",
                                                                }}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="Months">Months</option>
                                                                <option value="Years">Years</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>

                                            <div className="row gx-3 mb-3">
                                                {/* Form Group (organization name)*/}


                                                <div className="col-sm-6">
                                                    <label className="small mb-1" htmlFor="inputOrgName">
                                                        Technologies
                                                        <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                    </label>
                                                    <Select options={options} isMulti onChange={handleSkillsChange} value={selectedSkills} styles={{
                                                        multiValue: (styles, { data }) => ({
                                                            ...styles,
                                                            backgroundColor: '#286a94',
                                                        }),
                                                        multiValueLabel: (styles, { data }) => ({
                                                            ...styles,
                                                            color: 'white',
                                                        }),
                                                        multiValueRemove: (styles, { data }) => ({
                                                            ...styles,
                                                            color: 'white',
                                                            ':hover': {
                                                                backgroundColor: '#1a4b6d',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }} required />
                                                </div>

                                                <div className="col-sm-6">
                                                    {/* ========/ */}

                                                    <div className="input-row gap-0">
                                                        <label style={{ fontSize: '14px', gap: '0px' }}>Upload Images</label>
                                                        <input
                                                            type="file"
                                                            name="images"
                                                            accept="image/*"
                                                            className='p-1'
                                                            multiple
                                                            onChange={handleImageChange}
                                                        />

                                                    </div>

                                                </div>


                                            </div>


                                            <div className="row gx-3 mb-3">
                                                <div className="col-sm-6">
                                                    <div className="input-row">
                                                        <label>Description
                                                            <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                                        </label>
                                                        <textarea
                                                            name="description"
                                                            className="form-control"
                                                            rows={5}
                                                            id="inputOrgName"
                                                            value={project.description}
                                                            onChange={handleInputChange}
                                                            required
                                                            maxLength={500}
                                                        ></textarea>
                                                    </div>
                                                </div>

                                            </div>


                                            <div className="row gx-3 mb-3 mt-4">
                                                {project?.images?.length > 0 && <p>Project Images</p>}
                                                <div className="col-sm-12 d-flex ">
                                                    {/* Display uploaded images */}
                                                    {project.images.map((image, index) => (
                                                        <div key={index} className="align-items-center mb-2">


                                                            {typeof image === 'string' ? (
                                                                <img src={image} alt={`image1-${index}`} className="img-thumbnail" style={{ marginRight: '10px', width: '100px', height: '100px', objectFit: 'contain' }} />
                                                            ) : (
                                                                <img src={URL.createObjectURL(image)} alt={`Imag2e ${index}`} className="img-thumbnail" style={{ marginRight: '10px', width: '100px', height: '100px', objectFit: 'contain' }} />
                                                            )}

                                                            <div className='text_center mt-3'>
                                                                <MdDeleteOutline color='red' size={24} className='pointer' onClick={() => handleImageRemove(index)} />
                                                                {/* <button type="button" className="btn btn-danger btn-sm" >Delete</button> */}
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {/* Input field to add more images */}
                                                    {/* <input
                                                        type="file"
                                                        name="images"
                                                        accept="image/*"
                                                        className='p-1'
                                                        multiple
                                                        onChange={handleImageChange}
                                                    /> */}
                                                </div>
                                            </div>
                                            {/* Save changes button*/}
                                            <p style={{ color: 'blue', paddingLeft: '10px', fontSize: '14px' }}>
                                                Please upload a file larger than 4 KB and smaller than 2 MB.
                                            </p>
                                            <button className="add_skill_btn can_update_prof_btn" disabled={isLoading} type="submit">
                                                {isLoading ? "Loading..." : "Save changes"}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default UpdateProjectForm;
